import { METHOD } from 'services/method'

export const API_FAQ = {
    DETAIL: {
        api: '/v1/dashboard-admin/more-info/faq',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/more-info/faq',
        method: METHOD.PUT,
    },
}
